import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

const PageVisitTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const trackVisit = async () => {
      try {
        // Check if this session has already been tracked
        const sessionKey = 'page_visit_tracked';
        const sessionTimeout = 30 * 60 * 1000; // 30 minutes in milliseconds
        
        const lastVisit = sessionStorage.getItem(sessionKey);
        const now = Date.now();
        
        // Only track if no previous visit in this session, or if session expired
        if (!lastVisit || (now - parseInt(lastVisit)) > sessionTimeout) {
          await supabase.functions.invoke('track-visit', {
            body: {
              page_path: location.pathname,
              user_agent: navigator.userAgent,
              referrer: document.referrer || null
            }
          });
          
          // Mark this session as tracked
          sessionStorage.setItem(sessionKey, now.toString());
        }
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.error('Failed to track page visit:', error);
      }
    };

    trackVisit();
  }, [location.pathname]);

  return null;
};

export default PageVisitTracker;
